import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_MYSTAGE_ADMIN_TRAINER_LESSON_TOKEN_MSB } from '@/graphql/mystageLessonToken';
import logger from '@/modules/Logger';
import { bizmatesApi } from '@/utils/bizmatesApi';

/**
 * This does not have mbti, because this is for admin and trainer only,
 * mbti is for student only
 */
export const GetAdminTrainerLessonTokenService = {
  msb: async (lessonId, callback) => {
    logger.debug(`[Admin Trainer Lesson Token] Fetched lesson token from MSB GraphQL endpoint`,
      {
        operation: 'get-admin-trainer-token'
      }
    );
    
    let token = '';

    try {
      const client = myStageApolloProvider.defaultClient;
      const { data } = await client.query({
        query: GET_MYSTAGE_ADMIN_TRAINER_LESSON_TOKEN_MSB,
        fetchPolicy: 'no-cache',
        variables: {
          student_book_id: parseInt(lessonId)
        }
      });
      
      if (data?.myStageTestLesson?.token) {
        token = data.myStageTestLesson.token;
      } else {
        logger.error(`[Admin Trainer Lesson Token] Mystage Lesson Token request failed: No token data found`, {
          operation: 'get-admin-trainer-token',
          lesson_id: lessonId || ''
        });
      }
    } catch(error) {
      let message  = error.message;
        logger.error(`[Admin Trainer Lesson Token] Mystage Lesson Token request failed: ${message}`, {
          operation: 'get-admin-trainer-token',
          lesson_id: lessonId || ''
        });
    }

    callback(token);
  },

  legacy: async (lessonId, callback) => {
    logger.debug(`[Admin Trainer Lesson Token] Fetched lesson token from legacy endpoint`,
      {
        operation: 'get-admin-trainer-token'
      }
    );

    await bizmatesApi.get('lesson/adminTrainerToken', {
      params: { id: lessonId },
      timeout: 3000
    }, response => {
      callback(response.data);
    }, err => {
      let message  = err.message;
      logger.error(`[Admin Trainer Lesson Token] Mystage lesson Token request failed: ${message}`,
      {
        operation: 'get-admin-trainer-token',
        lesson_id: lessonId || ''
      });
      
      callback('');
    });
  }
};
